import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PROJECTS, scrollToId } from "@/data/content";

export default function Work() {
  return (
    <section id="projetos" className="py-28 md:py-40" data-testid="work-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <Overline>Portfólio</Overline>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-royal-deep md:text-6xl">
              Trabalho <em className="text-royal">selecionado.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-xs text-sm leading-relaxed text-muted-foreground">
              Uma seleção de projetos de branding, marketing, design, fotografia, vídeo e
              estratégia.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-x-10 gap-y-20 md:grid-cols-12">
          {PROJECTS.map((p, i) => (
            <Reveal
              key={p.category}
              delay={(i % 2) * 0.12}
              className={`group cursor-pointer md:col-span-6 ${
                p.wide ? "lg:col-span-7" : "lg:col-span-5"
              } ${i % 2 === 1 ? "lg:mt-24" : ""}`}
            >
              <div data-testid={`project-card-${i + 1}`}>
                <div className="relative overflow-hidden rounded-xl border border-royal-line bg-royal/5">
                  {p.video ? (
                    <video
                      ref={(el) => {
                        if (el) el.play().catch(() => {});
                      }}
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="auto"
                      className={`w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.05] ${
                        p.wide ? "aspect-[16/10]" : "aspect-[4/5] lg:aspect-[4/4.6]"
                      }`}
                      data-testid="project-video"
                    >
                      <source src={p.video.replace(".mp4", ".webm")} type="video/webm" />
                      <source src={p.video} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={p.image}
                      alt={`${p.category}, Creative`}
                      loading="lazy"
                      className={`w-full transition-transform duration-[900ms] ease-out group-hover:scale-[1.05] ${
                        p.contain ? "bg-white object-contain" : "object-cover"
                      } ${
                        p.wide ? "aspect-[16/10]" : "aspect-[4/5] lg:aspect-[4/4.6]"
                      }`}
                    />
                  )}
                  <div className="absolute inset-0 bg-royal/0 transition-colors duration-700 group-hover:bg-royal/15" />
                </div>
                <div className="mt-6 flex items-start justify-between gap-6">
                  <div>
                    <h3 className="font-display text-2xl font-medium text-royal-deep transition-colors duration-500 group-hover:text-royal md:text-3xl">
                      {p.category}
                    </h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">
                      {p.summary}
                    </p>
                  </div>
                  <span className="mt-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-royal/25 text-royal transition-all duration-500 group-hover:bg-royal group-hover:text-white">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-20 flex justify-center">
          <button
            onClick={() => scrollToId("#contacto")}
            className="group flex items-center gap-3 rounded-full border border-royal/30 px-8 py-4 text-sm font-bold text-royal transition-all duration-500 hover:border-royal hover:bg-royal hover:text-white"
            data-testid="work-cta-button"
          >
            O próximo projeto pode ser o teu
            <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
